import * as yup from 'yup';
import * as budgetApi from '../../lib/api/budget';
import { useSnackbar } from 'notistack';
import { useFormik } from 'formik';
// @mui
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import { createDraggablePaperComponent } from '../../components/common/dialog/DraggablePaper';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../components/common/dialog/BootstrapDialog';
import { useBoolean } from '../../hooks/useBoolean';
import TotalIndirectCostUploadForm from '../../components/total-overhead-budget-input/TotalIndirectCostUploadForm';

const PaperComponent = createDraggablePaperComponent('draggable-upload-dialog');

//application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:xlsx, application/vnd.ms-excel:xls
const SUPPORTED_FORMATS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
const TotalOverheadUploadModalContainer = ({
  title,
  open,
  onClose,
  refreshOnClose,
}) => {
  const isLoading = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    file: null,
  };
  const validationSchema = yup.object({
    file: yup
      .mixed()
      .required('파일을 선택하세요')
      .test('fileFormat', '지정된 XLSX파일만 가능합니다.', (value) => {
        //console.log(value);
        return value && SUPPORTED_FORMATS.includes(value.type);
      }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    isLoading.onTrue();
    let formData = new FormData();
    formData.append('file', values.file);
    //console.log(formData, 'formData');

    try {
      const response = await budgetApi.uploadExlByTotalInderectCost(formData);
      if (response.data.result === 'success') {
        refreshOnClose();
        enqueueSnackbar('업로드 되었습니다', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    } finally {
      isLoading.onFalse();
    }
  };

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-upload-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-upload-dialog"
        onClose={handleClose}
      >
        {title}
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        sx={{
          height: 200,
          overflowY: 'auto',
        }}
      >
        {isLoading.value ? (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        ) : (
          <TotalIndirectCostUploadForm formik={formik} />
        )}
      </DialogContent>
    </BootstrapDialog>
  );
};

export default TotalOverheadUploadModalContainer;
